module.exports = __webpack_public_path__ + "static/img/business72.16118d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business72.png
// module id = uPbc
// module chunks = 9